
import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { keywordOptions } from '../CommonFile/DropdownValues';

const Keywords = ({ selected, setSelected, viewResult }) => {

    const handleKeywordChange = (values) => {
        if (!values.length) return;

        const value = values[0];

        const keyword = (
            typeof value === 'string' ? value : value.label
        ).trim();

        if (!keyword) return;

        setSelected((prev) => {
            const exists = prev.some(
                (item) => item.toLowerCase() === keyword.toLowerCase()
            );

            return exists ? prev : [...prev, keyword];
        });
    };

    const handleRemove = (keywordToRemove) => {
        setSelected((prev) =>
            prev.filter((item) => item !== keywordToRemove)
        );
    };

    return (
        <Form className="search-contact-form-container">
            <Row className="mb-3">
                <Col md={viewResult ? 12 : 6}>
                    <Form.Group controlId="organizationKeywords">
                        <Form.Label className="pb-2 pt-2">
                            Organization Keywords
                        </Form.Label>

                        {/* Match the Technologies selected-item structure */}
                        <div className="type-head-selected-container mb-2">
                            {selected.map((keyword) => (
                                <div
                                    key={keyword}
                                    className="type-head-selected-options"
                                >
                                    <span
                                        className="cross-mark"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Remove ${keyword}`}
                                        onClick={() => handleRemove(keyword)}
                                        onKeyDown={(event) => {
                                            if (
                                                event.key === 'Enter' ||
                                                event.key === ' '
                                            ) {
                                                event.preventDefault();
                                                handleRemove(keyword);
                                            }
                                        }}
                                    >
                                        &times;
                                    </span>

                                    <span style={{ flex: 1 }}>
                                        {keyword}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <Typeahead
                            id="organization-keywords-typeahead"
                            className="w-100"
                            flip
                            options={keywordOptions
                                .map((option) => option.label)
                                .filter(
                                    (name) =>
                                        !selected.some(
                                            (item) =>
                                                item.toLowerCase() ===
                                                name.toLowerCase()
                                        )
                                )}
                            placeholder="Search or add keywords"
                            allowNew
                            newSelectionPrefix="Add new keyword: "
                            onChange={handleKeywordChange}
                            selected={[]}
                            inputProps={{
                                autoComplete: 'off'
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>
        </Form>
    );
};

export default Keywords;
